import { render, staticRenderFns } from "./anonymousNewsletterSignup.vue?vue&type=template&id=c0781770&"
import script from "./anonymousNewsletterSignup.vue?vue&type=script&lang=js&"
export * from "./anonymousNewsletterSignup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\actions-runner\\_work\\red.PandoSites\\red.PandoSites\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('c0781770', component.options)
    } else {
      api.reload('c0781770', component.options)
    }
    module.hot.accept("./anonymousNewsletterSignup.vue?vue&type=template&id=c0781770&", function () {
      api.rerender('c0781770', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "PandoSites.Web/Shared/MyAccount/Scripts/NewsletterSignup/anonymousNewsletterSignup.vue"
export default component.exports